"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reducer = exports.actionCreators = void 0;
exports.actionCreators = {
    requestFunction: function (pageload, uuid, service, reGetData) { return function (dispatch, getState) {
        var appState = getState();
        if ((appState && appState.keyToken && pageload == true && (appState.keyToken.stateUUID != uuid || appState.keyToken.stateService != service)) || reGetData) {
            console.log("call get mapkeytoken");
            fetch("v1/apps/" + uuid + "/services/" + service + "/mapkeytoken", {
                method: 'GET'
            })
                .then(function (response) { return response.json(); })
                .then(function (data) {
                dispatch({ type: 'RECEIVE_KEYTOKEN', model: data, uuid: uuid, service: service });
            })
                .then(function (error) {
            });
            dispatch({ type: 'REQUEST_KEYTOKEN' });
        }
    }; }
};
var unloadedState = { isLoading: false, response: undefined, stateUUID: "", stateService: "" };
var reducer = function (state, incomingAction) {
    if (state === undefined) {
        return unloadedState;
    }
    var action = incomingAction;
    switch (action.type) {
        case 'REQUEST_KEYTOKEN':
            return {
                isLoading: false,
                stateUUID: "",
                stateService: ""
            };
        case 'RECEIVE_KEYTOKEN':
            return {
                isLoading: true,
                response: action.model,
                stateUUID: action.uuid,
                stateService: action.service
            };
        default: return state;
    }
};
exports.reducer = reducer;
//# sourceMappingURL=KeyTokenByUUIDAndSerID.js.map